var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <nfd-select class="block padding-bottom-ms--1"params="props: {strategy: contractSelect}"> <span class="nfd-select__item-content"data-bind="text: $component.strategy.getItemName($data)"></span> </nfd-select> <!-- /ko -->';
}
return __p;
};
